import type { Messages } from '../catalogue.en'

export const scheduleReception: Partial<Messages> = {
  'schedule.receptionEdit.title': 'קבלה',
  'schedule.receptionEdit.edit': 'עריכה',
  'schedule.receptionEdit.empty': 'עדיין לא נרשם דבר',
  'schedule.receptionEdit.markUnset': 'לא צוין',
  'schedule.receptionEdit.markYes': 'כן',
  'schedule.receptionEdit.markNo': 'לא',
  'schedule.receptionEdit.stale': 'הביקור השתנה בזמן שהטופס היה פתוח. יש לקרוא אותו מחדש ואז לשמור שוב.',
  'schedule.receptionEdit.reread': 'קריאה מחדש',
  'schedule.receptionEdit.changed': 'עמית שינה את פרטי הקבלה בזמן שהטופס היה פתוח. מוצג מה שנשמר; יש לערוך שוב כדי לשנות.',
  'schedule.receptionEdit.withConfirm': 'נרשם יחד עם האישור.',
  'schedule.receptionHistory.title': 'היסטוריה',
  'schedule.receptionHistory.empty': 'לא נרשמו שינויי קבלה',
  'schedule.receptionHistory.loading': 'קורא את ההיסטוריה',
  'schedule.receptionHistory.loadFailed': 'לא ניתן היה לטעון את ההיסטוריה',
  'schedule.receptionHistory.loadMore': 'טעינת עוד',
  'schedule.receptionHistory.actor': 'על ידי חשבון',
  'schedule.receptionHistory.changed': 'שונה',
  'schedule.receptionHistory.firstRecord': 'רשומה ראשונה',
  'schedule.impactPanel.resources': 'משאבים מושפעים',
  'schedule.financeFacts.currency': 'מטבע',
  'schedule.refusal.title': 'מדוע נדחה',
  'schedule.refusal.blocks': 'חוסם את הפקודה',
  'schedule.refusal.warning': 'אזהרה בלבד',
  'schedule.refusal.resource': 'משאב',
  'schedule.refusal.requirement': 'דרישה',
  'schedule.refusal.when': 'מתי',
  'schedule.refusal.existingEvent': 'אירוע מתנגש',
  'schedule.refusal.existingReservation': 'הזמנה מתנגשת',
  'schedule.refusal.field': 'שדה',
}
